import { render, staticRenderFns } from "./TabelaRepeticao.vue?vue&type=template&id=d99c4fea"
import script from "./TabelaRepeticao.vue?vue&type=script&lang=js"
export * from "./TabelaRepeticao.vue?vue&type=script&lang=js"
import style0 from "./TabelaRepeticao.vue?vue&type=style&index=0&id=d99c4fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports